import Loader from "../Loader/Loader";
import cls from "./form-command.module.css";
import { useState } from "react";

export interface FormCommandProps {
  onSubmit?: () => void;
  onCancel?: () => void;
  commandText?: string;
  showCancelButton?: boolean;
  isBusy?: boolean;
}

function FormCommand(props: FormCommandProps) {
  const [isBusy, setIsBusy] = useState(props.isBusy);

  const buttonText = props.commandText ?? "Save Changes";

  let buttonContent = isBusy ? (
    <>
      <Loader spacing={1} />
      <span style={{ marginLeft: "5px" }}>{buttonText}</span>
    </>
  ) : (
    buttonText
  );

  return (
    <>
      {/* <hr /> */}
      <div className="mt-3 mb-1">
        <div className={cls.formCommand}>
          <div className={"form-group " + cls.formGroup}>
            <button
              className="btn btn-primary btn-sm cta mr-3"
              onClick={(e) => {
                setIsBusy(!isBusy);
                props.onSubmit?.();
              }}
            >
              {buttonContent}
            </button>

            {props.showCancelButton && (
              <button
                className="btn btn-outline btn-sm"
                onClick={() => {
                  setIsBusy(false);
                  props.onCancel?.();
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default FormCommand;
